<template>
  <div>
    <v-menu
      v-model="menu"
      :close-on-content-click="false"
      transition="scale-transition"
      location="bottom"
      min-width="auto"
    >
      <template v-slot:activator="{ props }">
        <v-text-field
          :model-value="displayValue"
          append-inner-icon="mdi-calendar"
          readonly
          v-bind="props"
          variant="outlined"
          density="compact"
          hide-details
          color="primary"
        ></v-text-field>
      </template>

      <v-locale-provider locale="en">
        <v-card elevation="4" class="d-inline-block rounded-lg">
          <v-date-picker
            v-model="internalDate"
            hide-header
            color="primary"
            elevation="0"
          ></v-date-picker>
          <v-time-picker
            v-model="internalTime"
            format="ampm"
            color="primary"
            elevation="0"
          ></v-time-picker>
        </v-card>
      </v-locale-provider>
    </v-menu>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import dayjs from "dayjs";

export default defineComponent({
  name: "DateTimePicker",

  props: {
    modelValue: {
      type: [String, null],
      default: "",
    },
  },

  emits: ["update:modelValue"],

  data() {
    return {
      menu: false,
    };
  },

  computed: {
    displayValue(): string {
      if (this.modelValue && dayjs(this.modelValue).isValid()) {
        return dayjs(this.modelValue).format("DD/MM/YYYY hh:mm A");
      }
      return "";
    },
    internalDate: {
      get(): Date | undefined {
        if (this.modelValue && dayjs(this.modelValue).isValid()) {
          return dayjs(this.modelValue).toDate();
        }
        return undefined;
      },
      set(val: Date | undefined) {
        if (val) {
          const time = this.getTimePart();
          this.emitDateTime(val, time);
        }
      },
    },
    internalTime: {
      get(): string | null {
        if (this.modelValue && dayjs(this.modelValue).isValid()) {
          return dayjs(this.modelValue).format("HH:mm");
        }
        return dayjs().format("HH:mm");
      },
      set(val: string | null) {
        if (val) {
          const date = this.getDatePart();
          this.emitDateTime(date, val);
          this.menu = false;
        }
      },
    },
  },

  methods: {
    getDatePart(): Date {
      if (this.modelValue && dayjs(this.modelValue).isValid()) {
        return dayjs(this.modelValue).toDate();
      }
      return new Date();
    },
    getTimePart(): string {
      if (this.modelValue && dayjs(this.modelValue).isValid()) {
        return dayjs(this.modelValue).format("HH:mm");
      }
      return dayjs().format("HH:mm");
    },
    emitDateTime(date: Date, time: string) {
      const [hours, minutes] = time.split(":").map(Number);
      const combined = dayjs(date)
        .hour(hours)
        .minute(minutes)
        .second(0)
        .format("YYYY-MM-DDTHH:mm");

      this.$emit("update:modelValue", combined);
    },
  },
});
</script>
